import React from 'react';
import './style.scss';

interface IProps {
    menuItems: { key: string; name: string; component: React.ReactNode }[];
    activeItem: string;
    onHandleActiveItem: (item: string) => void;
}

const HorizontalMenuWrap: React.FC<IProps> = ({ menuItems, activeItem, onHandleActiveItem }) => {
    return (
        <div className="horizontal__menu__wrap">
            <nav className="horizontal-menu">
                <div className="menu-container">
                    <ul>
                        {menuItems.map((item, index) => (
                            <li key={`horizontal-menu-${index}`} className={activeItem === item.key ? 'active' : ''} onClick={() => onHandleActiveItem(item.key)}>
                                {item.name}
                            </li>
                        ))}
                    </ul>
                </div>
            </nav>
        </div>
    );
};

export default React.memo(HorizontalMenuWrap);
